module.exports = __webpack_public_path__ + "static/media/hestia.474fc722.png";